import { Color } from "../maths/Color";
import { Point } from "../maths/Point";
import { Vector2 } from "../maths/Vector2";
import { Vector3 } from "../maths/Vector3";
import { Vector4 } from "../maths/Vector4";
import { OutOfRangeError } from "../utils/Error";
export class TweenValue {
    constructor(props) {
        this._props = props;
        this.nums = [];
    }
    get(name) {
        let prop = this._props.find(e => e.name == name);
        if (!prop)
            throw new Error(`Property '${name}' is not in tween.`);
        return this.read(prop.type, prop.offset);
    }
    set(name, value) {
        let prop = this._props.find(e => e.name == name);
        if (!prop)
            throw new Error(`Property '${name}' is not in tween.`);
        this.write(prop.type, prop.offset, value);
    }
    getAt(index) {
        let prop = this._props[index];
        if (!prop)
            throw new OutOfRangeError(index);
        return this.read(prop.type, prop.offset);
    }
    setAt(index, value) {
        let prop = this._props[index];
        if (!prop)
            throw new OutOfRangeError(index);
        this.write(prop.type, prop.offset, value);
    }
    get count() {
        return this._props.length;
    }
    copy(source) {
        this.nums.length = 0;
        this.nums.push(...source.nums);
        return this;
    }
    read(type, offset) {
        switch (type) {
            case 0:
                return this.nums[offset];
            case 1:
                return !!this.nums[offset];
            case 2:
                return Color.hexToString(this.nums[offset]);
            default:
                return type.read(this.nums, offset);
        }
    }
    write(type, offset, value) {
        switch (type) {
            case 0:
                this.nums[offset] = value;
                break;
            case 1:
                this.nums[offset] = value ? 1 : 0;
                break;
            case 2:
                this.nums[offset] = Color.stringToHex(value);
                break;
            default: {
                tmpArr.length = 0;
                type.write(tmpArr, value);
                tmpArr.forEach((v, i) => this.nums[offset + i] = v);
            }
        }
    }
}
const tmpArr = [];
function write(array, value) {
    value.writeTo(array, array.length);
}
export const TweenValueAdapterKey = Symbol();
const vec2 = new Vector2();
Vector2.prototype[TweenValueAdapterKey] = {
    write,
    read: (array, offset) => {
        return vec2.setValue(array[offset], array[offset + 1]);
    },
};
const vec3 = new Vector3();
Vector3.prototype[TweenValueAdapterKey] = {
    write,
    read: (array, offset) => {
        return vec3.setValue(array[offset], array[offset + 1], array[offset + 2]);
    },
};
const vec4 = new Vector4();
Vector4.prototype[TweenValueAdapterKey] = {
    write,
    read: (array, offset) => {
        return vec4.setValue(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
    },
};
const color = new Color();
Color.prototype[TweenValueAdapterKey] = {
    write,
    read: (array, offset) => {
        return color.setValue(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
    },
};
const pt = new Point();
Point.prototype[TweenValueAdapterKey] = {
    write: (array, value) => {
        array.push(value.x, value.y);
    },
    read: (array, offset) => {
        return pt.setTo(array[offset], array[offset + 1]);
    },
};
